import moment from 'moment';
import translatedTime from './translatedTime';

const formatFees = (fees) => {
  const formatedFees = fees.map(({
    fee_id: id, fee_duration: duration, period_id: periodId, quote_id: quoteId,
  }) => ({
    id,
    duration,
    periodId,
    quoteId,
  }));

  return formatedFees;
};

const formatOtherFees = (fees) => {
  const formatedFees = fees.map(({
    description: name, value: totalValue,
  }) => ({
    name,
    totalValue,
  }));

  return formatedFees;
};

const formatAccommodations = (accommodations) => {
  const formatedAccommodations = accommodations.map(({
    accommodation_id: id, accommodation_duration: duration, period_id: periodId, quote_id: quoteId,
  }) => ({
    id,
    duration,
    periodId,
    quoteId,
  }));

  return formatedAccommodations;
};

const formatCourses = (courses) => {
  const formatedCourses = courses.map(({
    course: { id },
    duration,
    enrolActive,
    materialActive,
    period_id: periodId,
    quote_id: quoteId,
    srcourse_id: srcourseId,
    srenrol_id: srenrolId,
    srmaterial_id: srmaterialId,
    srperiod_id: srperiodId,
    srperiod_active: srperiodActive,
    srcourse_active: srcourseActive,
    srenrol_active: srenrolActive,
    srmaterial_active: srmaterialActive,
  }) => ({
    id,
    duration,
    periodId,
    quoteId,
    enrolActive: enrolActive ? true : 'no',
    materialActive: materialActive ? true : 'no',
    srcourseId,
    srenrolId,
    srmaterialId,
    srperiodId,
    srperiodActive,
    srcourseActive,
    srenrolActive,
    srmaterialActive,
  }));

  return formatedCourses;
};

const formatDuration = (duration, typePeriod) => {
  if (typePeriod.at(-1) !== 's' && duration > 1) {
    return `${duration} ${translatedTime[typePeriod]}s`;
  } return `${duration} ${translatedTime[typePeriod]}`;
};
const formatInfos = (quote, hash, linktype) => ({
  id: quote.id,
  linktype,
  payment: {
    linktype,
    value: quote.totalvalues[0].value,
    valueWithoutSr: quote.totalvalues[0].value_without_sr,
    convertedValue: quote.converted_value,
    convertedValueWithoutSr: quote.converted_value_without_sr,
    currencyInfo: {
      currency: quote.currency[0].value,
      code: quote.currency[0].currency.code,
    },
    totalValues: quote.totalvalues,
  },
  accommodations: formatAccommodations(quote.accommodations),
  fees: formatFees(quote.fees),
  otherFees: formatOtherFees(quote.otherfees),
  description: quote.description,
  courses: formatCourses(quote.courses),
  destiny: quote.courses[0].course.campus.city
    ? quote.courses[0].course.campus.city?.name
    : '(Online)',
  destinyCountry: quote.courses[0].course.campus.city
    ? quote.courses[0].course.campus.city?.country_code
    : '(Online)',
  program: 'Intercâmbio',
  timeExpend: formatDuration(
    quote.courses[0].duration,
    quote.courses[0].course.typePeriod,
  ),
  workload: `${quote.courses[0].course.course.courseinfo.durationInt} ${quote.courses[0].course.course.courseinfo.durationDic}(s) per ${quote.courses[0].course.course.courseinfo.durationType}`,
  dueDate: moment(quote.dueDate).format('DD/MM/YYYY'),
  createdAt: moment(quote.created_at).format('DD/MM/YYYY'),
  hash,
  country: quote.opportunity.student.nationalityCountry,
  accountId: quote.account_id,
  code: quote.officeCount,
});

export default formatInfos;
